module.exports = require("./nus.d.ts");